export default __webpack_public_path__ + "static/media/steam.874ed595.webp";